import { render } from "./RqSystemSummary.vue?vue&type=template&id=66a74ce5"
import script from "./RqSystemSummary.vue?vue&type=script&lang=js"
export * from "./RqSystemSummary.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__